import { initReactI18next } from "react-i18next";
import i18next from "i18next";

// Real bug found + root-caused 2026-08-14, confirmed live on staging
// repeatedly across a whole session (every i18next key intermittently
// fell back to rendering its own raw key name instead of real text -
// "annual", "save_17_percent", "no_route_match" etc all seen literally on
// screen). The cause: this used to fetch translations at runtime over
// HTTP (i18next-http-backend, loadPath /assets/i18n/{{ns}}/{{lng}}.json)
// combined with `initImmediate: false` + `react: { useSuspense: false }`.
// That combination means the FIRST render (and any render that doesn't
// happen to re-fire after the async fetch resolves) proceeds before
// translations have actually loaded - i18next's own react binding does
// try to re-render once the fetch completes, but nothing here was
// guaranteeing every already-mounted consumer actually re-renders on that
// event. Purely a race, so it was inconsistent by nature - worse under
// real network latency (staging) than instant localhost, self-healing
// for components that happened to re-render later for unrelated reasons,
// which made it look like a flaky/one-off cache issue for a long time
// rather than the systemic timing bug it actually was.
//
// Fix: bundle the translations file directly (src/assets/i18n -
// webpack-processed, not the old public/assets/i18n copy, which CRA
// doesn't bundle and can no longer be fetched from at runtime here) and
// pass it via `resources`, so the full translation set is synchronously
// available the instant i18next.init() runs - no network round-trip, no
// race, no dependency on component re-render timing at all. The
// public/assets/i18n copy is now unused dead weight, left in place
// deliberately rather than deleted in case anything external still reads
// it directly - update BOTH files if translations ever change, or better,
// delete the public copy once confirmed nothing else depends on it.
import translations from "../../assets/i18n/translations/en.json";

i18next
  .use(initReactI18next)
  .init({
    lng: "en", // default language
    fallbackLng: "en",
    ns: ["translations"],
    debug: true,
    resources: {
      en: {
        translations,
      },
    },
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18next;
